import React, { Component } from 'react';
import { Link, Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';


import Header from './header';
import Sidebar from './sidebar/';
import Breadcrumb from './breadcrumb';
//import Aside from './aside';
//import Footer from './footer';

import routes from '../../routes';


class App extends Component {
 render() {
  return (
   <div className="app">
    <Header getOut={this.props.getOut} />
    <div className="app-body">
     <Sidebar />
     <main className="main">
      <Breadcrumb />
      <Container fluid>
       <Switch>
        {
         routes.map((route, idx) => {
          return route.component
          ? (<Route key={idx} path={route.path} exact={route.exact} render={props => (<route.component reqAPI={this.props.reqAPI} {...props} />)} />)
          : (null)
         })
        }
        <Redirect from="/" to="/cart" />
       </Switch>
      </Container>
     </main>
    </div>
   </div>
   );
 }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/index.js